import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocaleElement from "../../node_modules/element-ui/lib/locale/lang/en";
import zhLocaleElement from "../../node_modules/element-ui/lib/locale/lang/zh-CN";
import rootEN from "./messages/en.js";
import rootZH from "./messages/zh.js";
import options from "@/options";

Vue.use(VueI18n);

const messages = {
  "en-us": {
    ...rootEN,
    ...enLocaleElement,
    ...options.i18nMessage["en-us"]
  },
  "zh-cn": {
    ...rootZH,
    ...zhLocaleElement,
    ...options.i18nMessage["zh_CN"]
  }
};
const navig: any = navigator;
const navigatorLang: any = navig.language || navig.browserLanguage;
let lang = navigatorLang.toLowerCase();

if (!["en-us", "id"].includes(lang)) {
  lang = "en-us";
}

const i18n = new VueI18n({
  locale: lang,
  messages
});

export default i18n;
